/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareClaimRequestOneOf1
 */
export interface ShareClaimRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf1
     */
    type: ShareClaimRequestOneOf1TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShareClaimRequestOneOf1
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf1
     */
    level?: ShareClaimRequestOneOf1LevelEnum;
}


/**
 * @export
 */
export const ShareClaimRequestOneOf1TypeEnum = {
    Company: 'company'
} as const;
export type ShareClaimRequestOneOf1TypeEnum = typeof ShareClaimRequestOneOf1TypeEnum[keyof typeof ShareClaimRequestOneOf1TypeEnum];

/**
 * @export
 */
export const ShareClaimRequestOneOf1LevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ShareClaimRequestOneOf1LevelEnum = typeof ShareClaimRequestOneOf1LevelEnum[keyof typeof ShareClaimRequestOneOf1LevelEnum];


/**
 * Check if a given object implements the ShareClaimRequestOneOf1 interface.
 */
export function instanceOfShareClaimRequestOneOf1(value: object): value is ShareClaimRequestOneOf1 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function ShareClaimRequestOneOf1FromJSON(json: any): ShareClaimRequestOneOf1 {
    return ShareClaimRequestOneOf1FromJSONTyped(json, false);
}

export function ShareClaimRequestOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimRequestOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'companyId': json['companyId'],
        'level': json['level'] == null ? undefined : json['level'],
    };
}

export function ShareClaimRequestOneOf1ToJSON(json: any): ShareClaimRequestOneOf1 {
    return ShareClaimRequestOneOf1ToJSONTyped(json, false);
}

export function ShareClaimRequestOneOf1ToJSONTyped(value?: ShareClaimRequestOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'companyId': value['companyId'],
        'level': value['level'],
    };
}

